<template>
  <div class="pa-3 ma-3">
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <!-- Dialog para Agregar Puesto -->
    <v-dialog
      max-width="65%"
      v-model="dialogAdd"
      persistent
    >
      <v-card>
        <v-card-title>
          Agregar Puesto a Pagos con Tarjeta
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="selectedPuesto"
                :items="puestosDisponibles"
                item-text="nombre"
                item-value="id_puesto"
                label="Seleccione un Puesto"
                outlined
                dense
                hide-details
                :loading="loadingPuestos"
              >
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogAdd">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogAdd" :loading="loadingSave">Agregar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para Eliminar Puesto -->
    <v-dialog
      max-width="65%"
      v-model="dialogDelete"
      persistent
    >
      <v-card>
        <v-card-title>
          Eliminar Puesto de Pagos con Tarjeta de Débito
        </v-card-title>
        <v-card-text>
          ¿Está seguro de que desea eliminar el puesto "{{ selectedItem.nombre_puesto }}" de la lista de puestos que pueden recibir pagos con tarjeta de débito?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="closeDialogDelete">Cancelar</v-btn>
          <v-btn color="red" text @click="saveDialogDelete" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Botón para agregar -->
    <v-row>
      <v-col cols="12">
        <v-btn
          color="primary"
          @click="openDialogAdd"
        >
          Agregar Puesto Pago con Tarjeta
        </v-btn>
      </v-col>
    </v-row>

    <!-- Tabla de puestos con pago por tarjeta -->
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="items"
          :headers="headers"
          :loading="loading"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="openDialogDelete(item)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import VAlertDialog from '@/components/VAlertDialog.vue';

export default {
  components: {
    VAlertDialog
  },
  data: () => ({
    // ========== CONFIGURACIÓN DE MODO ==========
    useMockData: true, // Cambiar a false para usar API real
    // ===========================================
    
    dialogAdd: false,
    dialogDelete: false,
    loading: false,
    loadingPuestos: false,
    loadingSave: false,
    loadingDelete: false,
    items: [],
    puestos: [],
    selectedPuesto: null,
    selectedItem: {
      id_puesto_pago_tarjeta: null,
      id_puesto: null,
      nombre_puesto: ""
    },
    headers: [
      {
        text: "Puesto",
        value: "nombre_puesto",
        align: "center",
        width: "40%"
      },
      {
        text: "Tipo de Puesto",
        value: "puesto_area",
        align: "center",
        width: "30%",
      },
      {
        text: "Personas asignadas",
        value: "num_empleados_asignadas",
        align: "center",
        width: "15%",
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "15%"
      }
    ],
    // ========== DATOS MOCK ==========
    mockPuestosPagoTarjeta: [
      {
        id_puesto_pago_tarjeta: 1,
        id_puesto: "019ae4cd-38f4-7112-bfa5-875c7d22f95f",
        nombre_puesto: "Presidente del Consejo",
        puesto_area: "Consejo directivo",
        num_empleados_asignadas: 1
      },
      {
        id_puesto_pago_tarjeta: 2,
        id_puesto: "019ae4cd-76c5-79f2-9ca6-795fcb405d4d",
        nombre_puesto: "Secretario del Consejo",
        puesto_area: "Consejo directivo",
        num_empleados_asignadas: 1
      },
      {
        id_puesto_pago_tarjeta: 3,
        id_puesto: "019aa871-9e3e-73a6-8f16-7ac7950076f7",
        nombre_puesto: "Dirección General",
        puesto_area: "Dirección General",
        num_empleados_asignadas: 1
      },
      {
        id_puesto_pago_tarjeta: 4,
        id_puesto: "019aa8b5-fc5a-7d28-be3d-b204dede1fc0",
        nombre_puesto: "Jefe de Departamento Operativo",
        puesto_area: "De campo",
        num_empleados_asignadas: 1
      },
      {
        id_puesto_pago_tarjeta: 5,
        id_puesto: "019ae4cd-38f4-7112-bfa5-875c7d22f95f",
        nombre_puesto: "Presidente del Consejo",
        puesto_area: "Consejo directivo",
        num_empleados_asignadas: 1
      },
      {
        id_puesto_pago_tarjeta: 6,
        id_puesto: "019aa871-9e3e-73a6-8f16-7ac7950076f7",
        nombre_puesto: "Dirección General",
        puesto_area: "Dirección General",
        num_empleados_asignadas: 1
      },
      {
        id_puesto_pago_tarjeta: 7,
        id_puesto: "019aa8b5-fc5a-7d28-be3d-b204dede1fc0",
        nombre_puesto: "Jefe de Departamento Operativo",
        puesto_area: "De campo",
        num_empleados_asignadas: 1
      }
    ],
    mockNextId: 8
    // ===============================
  }),
  computed: {
    puestosDisponibles() {
      const idsAsignados = this.items.map(item => item.id_puesto);
      return this.puestos.filter(puesto => !idsAsignados.includes(puesto.id_puesto));
    }
  },
  mounted() {
    this.getItems();
    this.getPuestos();
  },
  methods: {
    // ========== MÉTODOS PRINCIPALES (llaman a mock o API según configuración) ==========
    getItems() {
      if (this.useMockData) {
        this.getItemsMock();
      } else {
        this.getItemsAPI();
      }
    },
    saveAdd(idPuesto) {
      if (this.useMockData) {
        return this.saveAddMock(idPuesto);
      } else {
        return this.saveAddAPI(idPuesto);
      }
    },
    deleteItem(id) {
      if (this.useMockData) {
        return this.deleteItemMock(id);
      } else {
        return this.deleteItemAPI(id);
      }
    },

    // ========== MÉTODOS MOCK ==========
    getItemsMock() {
      this.loading = true;
      setTimeout(() => {
        this.items = [...this.mockPuestosPagoTarjeta];
        this.loading = false;
      }, 500); // Simula delay de red
    },
    saveAddMock(idPuesto) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          // Verificar si ya existe
          const existe = this.mockPuestosPagoTarjeta.some(item => item.id_puesto === idPuesto);
          if (existe) {
            reject({ response: { status: 409 } });
            return;
          }

          // Buscar el nombre del puesto
          const puesto = this.puestos.find(p => p.id_puesto === idPuesto);
          
          // Agregar nuevo item
          const nuevoItem = {
            id_puesto_pago_tarjeta: this.mockNextId++,
            id_puesto: idPuesto,
            nombre_puesto: puesto.nombre
          };
          this.mockPuestosPagoTarjeta.push(nuevoItem);
          resolve();
        }, 500);
      });
    },
    deleteItemMock(id) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const index = this.mockPuestosPagoTarjeta.findIndex(item => item.id_puesto_pago_tarjeta === id);
          if (index !== -1) {
            this.mockPuestosPagoTarjeta.splice(index, 1);
          }
          resolve();
        }, 500);
      });
    },

    // ========== MÉTODOS API ==========
    getItemsAPI() {
      this.loading = true;
      axios
        .get('/RecursosHumanos/ListarPuestosPagoTarjeta')
        .then(response => {
          this.items = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    getPuestos() {
      this.loadingPuestos = true;
      axios
        .get('/RecursosHumanos/ListarPuestos')
        .then(response => {
          this.puestos = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingPuestos = false;
        })
    },
    saveAddAPI(idPuesto) {
      return axios.post('/RecursosHumanos/AgregarPuestoPagoTarjeta', {
        id_puesto: idPuesto
      });
    },
    deleteItemAPI(id) {
      return axios.delete(`/RecursosHumanos/EliminarPuestoPagoTarjeta/${id}`);
    },

    // ========== MÉTODOS DE UI ==========
    openDialogAdd() {
      this.selectedPuesto = null;
      this.dialogAdd = true;
    },
    closeDialogAdd() {
      this.selectedPuesto = null;
      this.dialogAdd = false;
    },
    saveDialogAdd() {
      if (this.selectedPuesto == null) {
        this.$refs.alert.setMessage("", "Debe seleccionar un puesto");
        this.$refs.alert.open();
        return;
      }

      this.loadingSave = true;

      this.saveAdd(this.selectedPuesto)
        .then(() => {
          this.getItems();
          this.closeDialogAdd();
        })
        .catch(error => {
          if (error.response && error.response.status == 409) {
            this.$refs.alert.setMessage("", "Este puesto ya está en la lista.");
            this.$refs.alert.open();
          } else {
            this.$refs.alert.setMessage("", "Error al agregar el puesto.");
            this.$refs.alert.open();
          }
        })
        .finally(() => {
          this.loadingSave = false;
        });
    },
    openDialogDelete(item) {
      this.selectedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    closeDialogDelete() {
      this.selectedItem = {
        id_puesto_pago_tarjeta: null,
        id_puesto: null,
        nombre_puesto: ""
      };
      this.dialogDelete = false;
    },
    saveDialogDelete() {
      this.loadingDelete = true;
      
      this.deleteItem(this.selectedItem.id_puesto_pago_tarjeta)
        .then(() => {
          this.closeDialogDelete();
          this.getItems();
        })
        .catch(error => {
          console.log(error);
          this.$refs.alert.setMessage("", "Error al eliminar el puesto.");
          this.$refs.alert.open();
        })
        .finally(() => {
          this.loadingDelete = false;
        });
    }
  }
}
</script>